/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How platform fees are applied to entry fee challenges
 * @export
 */
export const ChallengeFeeStructure = {
    DEDUCTION: 'DEDUCTION',
    ADDON: 'ADDON'
} as const;
export type ChallengeFeeStructure = typeof ChallengeFeeStructure[keyof typeof ChallengeFeeStructure];


export function instanceOfChallengeFeeStructure(value: any): boolean {
    for (const key in ChallengeFeeStructure) {
        if (Object.prototype.hasOwnProperty.call(ChallengeFeeStructure, key)) {
            if (ChallengeFeeStructure[key as keyof typeof ChallengeFeeStructure] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChallengeFeeStructureFromJSON(json: any): ChallengeFeeStructure {
    return ChallengeFeeStructureFromJSONTyped(json, false);
}

export function ChallengeFeeStructureFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeFeeStructure {
    return json as ChallengeFeeStructure;
}

export function ChallengeFeeStructureToJSON(value?: ChallengeFeeStructure | null): any {
    return value as any;
}

export function ChallengeFeeStructureToJSONTyped(value: any, ignoreDiscriminator: boolean): ChallengeFeeStructure {
    return value as ChallengeFeeStructure;
}

